import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import AbstractNode from './AbstractNode';
import EnvelopeDistance from './EnvelopeDistance';
import Comparable from '../../../../../java/lang/Comparable';
var BoundablePair = /*#__PURE__*/function () {
  function BoundablePair() {
    _classCallCheck(this, BoundablePair);
    BoundablePair.constructor_.apply(this, arguments);
  }
  _createClass(BoundablePair, [{
    key: "maximumDistance",
    value: function maximumDistance() {
      return EnvelopeDistance.maximumDistance(this._boundable1.getBounds(), this._boundable2.getBounds());
    }
  }, {
    key: "expandToQueue",
    value: function expandToQueue(priQ, minDistance) {
      var isComp1 = BoundablePair.isComposite(this._boundable1);
      var isComp2 = BoundablePair.isComposite(this._boundable2);
      if (isComp1 && isComp2) {
        if (BoundablePair.area(this._boundable1) > BoundablePair.area(this._boundable2)) {
          this.expand(this._boundable1, this._boundable2, false, priQ, minDistance);
          return null;
        } else {
          this.expand(this._boundable2, this._boundable1, true, priQ, minDistance);
          return null;
        }
      } else if (isComp1) {
        this.expand(this._boundable1, this._boundable2, false, priQ, minDistance);
        return null;
      } else if (isComp2) {
        this.expand(this._boundable2, this._boundable1, true, priQ, minDistance);
        return null;
      }
      throw new IllegalArgumentException('neither boundable is composite');
    }
  }, {
    key: "isLeaves",
    value: function isLeaves() {
      return !(BoundablePair.isComposite(this._boundable1) || BoundablePair.isComposite(this._boundable2));
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var nd = o;
      if (this._distance < nd._distance) return -1;
      if (this._distance > nd._distance) return 1;
      return 0;
    }
  }, {
    key: "expand",
    value: function expand(bndComposite, bndOther, isFlipped, priQ, minDistance) {
      var children = bndComposite.getChildBoundables();
      for (var i = children.iterator(); i.hasNext();) {
        var child = i.next();
        var bp = null;
        if (isFlipped) bp = new BoundablePair(bndOther, child, this._itemDistance);else bp = new BoundablePair(child, bndOther, this._itemDistance);
        if (bp.getDistance() < minDistance) priQ.add(bp);
      }
    }
  }, {
    key: "getBoundable",
    value: function getBoundable(i) {
      if (i === 0) return this._boundable1;
      return this._boundable2;
    }
  }, {
    key: "getDistance",
    value: function getDistance() {
      return this._distance;
    }
  }, {
    key: "distance",
    value: function distance() {
      if (this.isLeaves()) return this._itemDistance.distance(this._boundable1, this._boundable2);
      return this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._boundable1 = null;
      this._boundable2 = null;
      this._distance = null;
      this._itemDistance = null;
      var boundable1 = arguments[0],
        boundable2 = arguments[1],
        itemDistance = arguments[2];
      this._boundable1 = boundable1;
      this._boundable2 = boundable2;
      this._itemDistance = itemDistance;
      this._distance = this.distance();
    }
  }, {
    key: "area",
    value: function area(b) {
      return b.getBounds().getArea();
    }
  }, {
    key: "isComposite",
    value: function isComposite(item) {
      return item instanceof AbstractNode;
    }
  }]);
  return BoundablePair;
}();
export { BoundablePair as default };